import { render, staticRenderFns } from "./Plane.vue?vue&type=template&id=d32a2d3c&scoped=true&"
import script from "./Plane.vue?vue&type=script&lang=js&"
export * from "./Plane.vue?vue&type=script&lang=js&"
import style0 from "./Plane.vue?vue&type=style&index=0&id=d32a2d3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32a2d3c",
  null
  
)

export default component.exports